var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductPartnerAdvantagesImplModule',{attrs:{"instance":_vm.instance,"backgroundColor":_vm.backgroundColor,"partnerAdvantages":_vm.partnerAdvantages,"modelAdvantages":_vm.modelAdvantages}})}
var staticRenderFns = []

export { render, staticRenderFns }